<script lang="ts">
  import type { SVGAttributes } from "svelte/elements";

  interface Props extends SVGAttributes<SVGSVGElement> {
    size?: number;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M3.36 10.133a1.68 1.68 0 1 1-1.68-1.68h1.68v1.68zm.853 0a1.68 1.68 0 0 1 3.36 0v4.2a1.68 1.68 0 1 1-3.36 0v-4.2z"
    fill="#E01E5A"
  />
  <path
    d="M5.893 3.36a1.68 1.68 0 1 1 1.68-1.68v1.68h-1.68zm0 .853a1.68 1.68 0 1 1 0 3.36h-4.2a1.68 1.68 0 1 1 0-3.36h4.2z"
    fill="#36C5F0"
  />
  <path
    d="M12.64 5.893a1.68 1.68 0 1 1 1.68 1.68h-1.68v-1.68zm-.853 0a1.68 1.68 0 0 1-3.36 0v-4.2a1.68 1.68 0 1 1 3.36 0v4.2z"
    fill="#2EB67D"
  />
  <path
    d="M10.107 12.64a1.68 1.68 0 1 1-1.68 1.68v-1.68h1.68zm0-.853a1.68 1.68 0 1 1 0-3.36h4.2a1.68 1.68 0 1 1 0 3.36h-4.2z"
    fill="#ECB22E"
  />
</svg>
